import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import { formatDateTime } from '../../../common/utils/helpers';
import rules from '../../../common/rules/rules';
import { Switch, Input } from 'antd';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 6,
  },
};

@translate()
@Form.create()
export default class SettingDetail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    setting: PropTypes.object,
    isUpdating: PropTypes.bool.isRequired,
    settingEditable: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
  };

  handleSubmit = e => {
    e.preventDefault();
    const { form, onSubmit, setting } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        if (setting.type === 'boolean') {
          values.value = values.value ? '1' : '0';
        }

        onSubmit(values);
      }
    });
  };

  handleEdit = e => {
    e.preventDefault();
    const { setting, onEdit } = this.props;
    onEdit(setting.id);
  };

  handleCancelEdit = e => {
    e.preventDefault();
    const { onEdit } = this.props;
    onEdit('');
  };

  render() {
    const { setting, isUpdating, settingEditable, t } = this.props;
    const { getFieldDecorator } = this.props.form;

    const isEditable = settingEditable === setting.id;

    return (
      <Spin spinning={isUpdating}>
        <h1>{t('Detail nastavenia')}</h1>

        <Form onSubmit={this.handleSubmit}>
          <Form.Item {...formItemLayout} label={t('Názov')}>
            <span>{t(`SETTING_${setting.key}`)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Popis')}>
            <span>{t(`SETTING_${setting.key}_DESC`)}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Kľúč')}>
            <span>
              <pre>{setting.key}</pre>
            </span>
          </Form.Item>

          { setting.type === 'boolean' ?
            <Form.Item {...formItemLayout} label={t('Hodnota')}>
              {!isEditable && <span>{setting.value === '1' ? t('áno') : t('nie')}</span>}
              {isEditable &&
                getFieldDecorator('value', {
                  initialValue: setting.value === '1',
                  valuePropName: 'checked'
                })(
                  <Switch
                      name={'value'}
                      size={'default'}
                      checkedChildren={t('áno')}
                      unCheckedChildren={t('nie')}
                      autoFocus={true}
                  />
                )
              }
            </Form.Item>
            :
            <Form.Item {...formItemLayout} label={t('Hodnota')}>
              {!isEditable && <span>{setting.value}</span>}
              {isEditable &&
                getFieldDecorator('value', {
                  rules: rules.required,
                  initialValue: setting.value,
                })(
                  <Input size="default" placeholder={t('Hodnota')} autoFocus />
                )}
            </Form.Item>
          }

          <Form.Item {...formItemLayout} label={t('Naposledny upravené')}>
            <span>{formatDateTime(setting.updatedAt)}</span>
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            {!isEditable && (
              <Button size="default" className="btn-inline" type="dashed" onClick={this.handleEdit}>
                {t('Upraviť údaje')}
              </Button>
            )}
            {isEditable && (
              <Button size="default" className="btn-inline" type="primary" htmlType="submit">
                {t('Uložiť')}
              </Button>
            )}
            {isEditable && (
              <Button size="default" className="btn-inline" onClick={this.handleCancelEdit}>
                {t('Zrušiť úpravy')}
              </Button>
            )}
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/setting-management/components/SettingDetail.js